// https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/
export const stripHTML = html => {
   if (typeof html !== 'string') {
      return null;
   }

   return html.replace(/(<([^>]+)>)/gi, '');
};
